var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2631 2.8125H17.7029C17.4841 2.8125 17.2765 2.91295 17.1426 3.08482L7.93947 14.7433L3.52652 9.15179C3.45976 9.06703 3.37467 8.9985 3.27764 8.95133C3.1806 8.90417 3.07414 8.8796 2.96625 8.87946H1.40598C1.25643 8.87946 1.17384 9.05134 1.26536 9.16741L7.3792 16.9129C7.66491 17.2746 8.21402 17.2746 8.50197 16.9129L19.4038 3.09821C19.4953 2.98438 19.4127 2.8125 19.2631 2.8125Z",
    fill: "#A0D911"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.1d36b1c9cd7f2c35a980679e3cfedadf.svg";
export { ForwardRef as ReactComponent };